function SecondsToHours (time) {
  const secondsInitial = parseInt(time, 10)
  let hours = Math.floor(secondsInitial / 3600)
  let minutes = Math.floor((secondsInitial - (hours * 3600)) / 60)
  let seconds = secondsInitial - (hours * 3600) - (minutes * 60)

  if (hours < 10) {
    hours = `0${hours}`
  }

  if (minutes < 10) {
    minutes = `0${minutes}`
  }

  if (seconds < 10) {
    seconds = `0${seconds}`
  }

  return `${hours}:${minutes}:${seconds}`
}

export default SecondsToHours



// WEBPACK FOOTER //
// ./src/utils/filters/SecondsToHours.js